
export const PAGINA_LOGIN = '/pagina_login'
export const PAGINA_SOPORTE = '/pagina_soporte'
export const PAGINA_LISTA_CURSOS = '/PAGINA_LISTA_CURSOS'
export const PAGINA_CURSO = '/pagina_curso'
export const PAGINA_INFORMACION = '/pagina_informacion'
export const PAGINA_INICIO = '/pagina_inicio'
export const PAGINA_CONTACTENOS = '/pagina_contactenos'
export const PAGINA_DRAFT = '/pagina_draft'
